// extracted by mini-css-extract-plugin
export default {"title":"DialogHeader_title__LdqWe","description":"DialogHeader_description__mdQXy"};